<template>
  <div class="my-back">
    <div class="flex-back flex" @click="goBack">
      <i class="el-icon-arrow-left"></i>{{ $t("message.back") }}
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "MyBack",
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$emit("onback");
    }
  }
};
</script>
<style lang="less" scoped>
.my-back {
  align-items: center;
  font-size: 20px;
  height: 40px;
  padding: 0 14px 0 6px;
  display: flex;
  justify-content: space-between;
  .flex-back {
    align-items: center;
  }
}
.el-icon-arrow-left {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/MyBack.vue